import { render } from "./ForgotPassword.vue?vue&type=template&id=4a06eba0&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=4a06eba0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a06eba0"

export default script